import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createDiseñosCurricularesSchema = yup.object({
  nombre: yup.string().required(DEFAULT_MESSAGES.REQUIRED),

  descripcion: yup.string().optional(),

  fecha_publicacion: yup.date().required(DEFAULT_MESSAGES.REQUIRED),

  estado_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),

  documentacion_adjunta: yup
    .array()
    .of(
      yup
        .mixed()
        .test(
          "es-archivo",
          "Uno o más archivos no son válidos",
          (value) => value instanceof File,
        ),
    )
    .required(DEFAULT_MESSAGES.REQUIRED)
    .min(1, "Debe subir al menos un archivo")
    .max(10, "Demasiados archivos (máximo 10)"),

  nivel_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),
});
